function Logo({ light = false }: { light?: boolean }) {
  return (
    <span className="inline-flex items-center gap-2.5">
      <svg width="34" height="34" viewBox="0 0 34 34" fill="none" aria-hidden="true">
        <rect width="34" height="34" rx="8" fill={light ? '#F5A623' : '#12283F'} />
        <path d="M5 26 L17 8 L29 26" stroke={light ? '#12283F' : '#8FB2D6'} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
        <path d="M11 26 V19 H23 V26" stroke={light ? '#12283F' : '#F5A623'} strokeWidth="2.2" strokeLinejoin="round" />
        <path d="M14 19 L17 15 L20 19" stroke={light ? '#12283F' : '#F5A623'} strokeWidth="2.2" strokeLinejoin="round" strokeLinecap="round" />
      </svg>
      <span className={`text-lg font-extrabold tracking-tight ${light ? 'text-white' : 'text-ink'}`}>
        Dormer<span className={light ? 'text-signal' : 'text-blueprint-600'}>Calculator</span>
      </span>
    </span>
  )
}

export default Logo
